import { ErrorType, ERRORS, ErrorInfo } from "../../types";
import { AuthError, HttpError } from "../HttpError";

export const chatMessageErrorHandler = (error: HttpError): ErrorInfo => {
  if (error instanceof AuthError) {
    return {
      error: ERRORS.SESSION_EXPIRED,
      errorType: ErrorType.SESSION_EXPIRED,
    };
  }

  if (error.status === 400) {
    return {
      error: ERRORS.TOO_MANY_TOKENS,
      errorType: ErrorType.TOO_MANY_TOKENS,
    };
  }

  return {
    error: ERRORS.UNEXPECTED,
    errorType: ErrorType.OTHER,
  };
};
